import {
  fullNameSchema,
  fullNameUI,
  titleUI,
  dateOfBirthSchema,
  dateOfBirthUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { isRelationshipToVeteran } from '../../../utils/helpers';
import content from '../../../utils/content.json';

export const pageTitle = formData =>
  isRelationshipToVeteran(formData) === 'custodian'
    ? content['your-info-title-custodian']
    : content['your-info-title'];

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(({ formData }) => pageTitle(formData)),
    // Change to yourName, in transform if spouse/child switch to claimantName
    // If custodian, change to filingCustodianName
    // Statement of truth uses yourName
    yourName: fullNameUI(),
    yourDateOfBirth: dateOfBirthUI({
      monthSelect: false,
      hideIf: formData => isRelationshipToVeteran(formData) === 'custodian',
      required: formData => isRelationshipToVeteran(formData) !== 'custodian',
    }),
  },
  schema: {
    type: 'object',
    required: ['yourName'],
    properties: {
      yourName: fullNameSchema,
      yourDateOfBirth: dateOfBirthSchema,
    },
  },
};
